import { ApiResponse, fetcher } from './base-api';
import {
  ArticleEntity,
  ArticleListResponse,
  GetArticleListParams,
} from './types/article.type';
import { SiteCategory } from './types/globals.type';

export const getPrivacyArticleList = async (): Promise<
  ApiResponse<ArticleEntity[]>
> => {
  return fetcher<ArticleEntity[]>('/article/privacy');
};

export const getArticleList = async (
  params?: GetArticleListParams,
): Promise<ApiResponse<ArticleListResponse>> => {
  return fetcher<ArticleListResponse>('/article', {
    params: { ...params, category: SiteCategory.TRAINING },
  });
};

export const getArticleDetail = async (
  id: number,
): Promise<ApiResponse<ArticleEntity>> => {
  return fetcher<ArticleEntity>(`/article/${id}`);
};

// export const getMainTopArticleList = async (): Promise<
//   ApiResponse<ArticleEntity[]>
// > => {
//   return fetcher<ArticleEntity[]>('/article/main-top', {
//     params: { category: SiteCategory.TRAINING },
//   });
// };

/** 도로연수 블로그 상단 노출 글 (신규 게시글 3개) */
export const getBlogTopArticleList = async (): Promise<
  ApiResponse<ArticleEntity[]>
> => {
  return fetcher<ArticleEntity[]>('/article/training/blog-top');
};

/** 도로연수 블로그 페이징 */
export const getBlogArticleList = async (
  params?: GetArticleListParams,
): Promise<ApiResponse<ArticleListResponse>> => {
  return fetcher<ArticleListResponse>('/article/training/blog', { params });
};
